import { render, staticRenderFns } from "./SecretStorageForm.vue?vue&type=template&id=d724fc96&scoped=true"
import script from "./SecretStorageForm.vue?vue&type=script&lang=js"
export * from "./SecretStorageForm.vue?vue&type=script&lang=js"
import style0 from "./SecretStorageForm.vue?vue&type=style&index=0&id=d724fc96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d724fc96",
  null
  
)

export default component.exports